import { handleAuthorization, handleOkResponseJson } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterProdutosAsync,
    obterProdutosPaginadosAsync,
    enviarProdutoAsync,
    editarProdutoAsync,
	downloadLista
}

export const obterProdutosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterListaProdutosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto/obterListaProdutos`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterListaServicosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto/obterListaServicos`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterListaServicosInternoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto/obterListaServicosInterno`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarProdutoAsync = async (tipos, descricao, codigo, idGrupo, idSubGrupo, idMarca, idUnidadeMedida, idDepartamento, possuiConversao, imagem, conversoes) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ tipos, descricao, codigo, idGrupo, idSubGrupo, idMarca, idUnidadeMedida, idDepartamento, possuiConversao, imagem, conversoes })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarProdutoAsync = async (id, tipos, descricao, codigo, idGrupo, idSubGrupo, idMarca, idUnidadeMedida, idDepartamento, possuiConversao, imagem, ativo, conversoes) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, tipos, descricao, codigo, idGrupo, idSubGrupo, idMarca, idUnidadeMedida, idDepartamento, possuiConversao, imagem, ativo, conversoes })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Produto/downloadProdutos`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'produtos' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}

export const obterProdutosPaginadosAsync = async (pagina, tamanhoPagina) => {
    const params = new URLSearchParams({
        pagina: String(pagina),
        tamanhoPagina: String(tamanhoPagina),
    });
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Produto/obterListaPaginada?${params.toString()}`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}
